import { exec, getApiToken } from '../utils';
import type {
  AllPermissions,
  FetchPermissionsArgs,
} from '@src/types';

export const fetchPermissions = async ({ token }: FetchPermissionsArgs): Promise<AllPermissions> => {
  const apiToken = await getApiToken(token);

  const query = `
    query fetchPermissions(
      $token: String!
    ) {
      user(token: $token) {
        userPermissionsByPartner
      }
    }
  `;

  interface UserResponse {
    user: {
      userPermissionsByPartner: AllPermissions;
    };
  }

  const data = await exec<{ token: string }, UserResponse>(
    query, {
    variables: {
      token: apiToken,
    },
  },
  );

  return data.user.userPermissionsByPartner;
};
